export const makeGrid = (size: number) => {
  const grid = (col: number) => (100 / size) * col;

  return Array.from(Array(size + 1))
    .map((_, index) => `${grid(index)}%`)
    .slice(1);
};

export const grid = (column: number, size: number = 12) => `${(100 / size) * column}%`;
